import { Formik, Form } from 'formik'
import Input from './Input.js'
import InputPswd from './InputPswd.js'
import Button from './Button.js'

const Formulario = (props) => {

    return(
        <Formik
        initialValues={props.initialValues}
        onSubmit={props.onSubmit}
        validationSchema={props.validationSchema}
        >
          <Form>
            <div  className='relative'>
              <Input name='LoginId' type='text'>Nombre de usuario</Input>
              {/*<Input name='password' type='password'>Contraseña</Input>*/}
              <InputPswd name='password'>Contraseña</InputPswd>
              {/*<Input name='checked' type='checkbox'>Recordar mi usuario</Input>*/}
            </div>
            <div className="flex justify-center">
              <Button className="mt-8 m-2 px-6 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500 ease text-white rounded-lg" type='submit'>Ingresar</Button>
            </div>
          </Form>
        </Formik>
    )
}

export default Formulario